export default __webpack_public_path__ + "static/media/safari.60cf5e2b.svg";